<template>
<footer id="footer">
    <div class="footer-top">
        <div class="container">
            <div class="row">
                <div class="span3 social">
                    <h3>Follow Us</h3>
                    <p>Follow us in social media</p>
                    <a target="_blank" class="sbtnf sbtnf-rounded color color-hover icon-instagram" href="https://instagram.com/girish_jewellers_"></a>
                    <a class="sbtnf sbtnf-rounded color color-hover icon-facebook" href="#"></a>
                    <a class="sbtnf sbtnf-rounded color color-hover icon-twitter" href="#"></a>
                    <a class="sbtnf sbtnf-rounded color color-hover icon-linkedin" href="#"></a>
                </div>
                <div class="span3 newsletter">
                    <h3>Newsletter</h3>
                    <p>Sign up for newsletter</p>
                    <form>
                    <input class="input-block-level" type="email">
                    <button class="submit"><i class="fa fa-arrow-circle-o-right"></i></button>
                    </form>
                </div>
                <div class="span3 nav-box">
                    <h3>Information</h3>
                    <nav>
                    <ul>
                        <li><router-link to="/about">About Us</router-link></li>
                        <li><router-link to="/contact">Contact Us</router-link></li>
                        <li><router-link to="/cart">View Cart</router-link></li>
                        <li><router-link to="/checkout">Checkout</router-link></li>
                    </ul>
                    </nav>
                </div>
                <div class="span3 nav-box">
                    <h3>My account</h3>
                    <nav>
                    <ul>
                        <li v-if="results.session.is_login"><router-link to="/account">My account</router-link></li>
                        <li v-if="results.session.is_login"><router-link to="/order-history">Order Hitory</router-link></li>
                        <li v-if="results.session.is_login"><router-link to="/update-profile">Profile</router-link></li>
                        <li v-if="results.session.is_login"><a href="javascript:void(0);" v-on:click="Logout()">Logout</a></li>

                        <li v-if="!results.session.is_login"><router-link to="/login">Login / Sign-up</router-link></li>
                        <li v-if="!results.session.is_login"><router-link to="/create-account">Create Account</router-link></li>

                    </ul>
                    </nav>
                </div>
            </div>
        </div>
    </div><!-- .footer-top -->
    <div class="footer-bottom">
        <div class="container">
            <div class="row">
            <div class="span3 copyright">Copyright &copy; Girish Jewellers, 2022</div>
            <div class="span3 phone">
                <div class="footer-icon">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    width="16px" height="16px" viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve">
                    <path fill="#c6c6c6" d="M11.001,0H5C3.896,0,3,0.896,3,2c0,0.273,0,11.727,0,12c0,1.104,0.896,2,2,2h6c1.104,0,2-0.896,2-2
                    c0-0.273,0-11.727,0-12C13.001,0.896,12.105,0,11.001,0z M8,15c-0.552,0-1-0.447-1-1s0.448-1,1-1s1,0.447,1,1S8.553,15,8,15z
                    M11.001,12H5V2h6V12z"/>
                </svg>
                </div>
                <strong class="title">Call Us:</strong> <br>1.) +91 93274 44450,<br> 2.) +91 97250 02345
            </div>
            <div class="span3 address">
                <div class="footer-icon">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    width="16px" height="16px" viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve">
                    <g>
                    <g>
                        <path fill="#c6c6c6" d="M8,16c-0.256,0-0.512-0.098-0.707-0.293C7.077,15.491,2,10.364,2,6c0-3.309,2.691-6,6-6
                        c3.309,0,6,2.691,6,6c0,4.364-5.077,9.491-5.293,9.707C8.512,15.902,8.256,16,8,16z M8,2C5.795,2,4,3.794,4,6
                        c0,2.496,2.459,5.799,4,7.536c1.541-1.737,4-5.04,4-7.536C12.001,3.794,10.206,2,8,2z"/>
                    </g>
                    <g>
                        <circle fill="#c6c6c6" cx="8.001" cy="6" r="2"/>
                    </g>
                    </g>
                </svg>
                </div>
                "Dhanak House", 27, Prahlad ploat corner,<br> Nr. Patel Vijay Dairy, Prahlad main road,<br> Rajkot - 360001, Gujarat, India.
            </div>
            <div class="span3">
                <a href="#" class="up pull-right"><i class="icon-arrow-up icon-white"></i></a>
            </div>
            </div>
        </div>
    </div>
</footer>
</template>    
<script>
import {mapGetters, mapActions} from "vuex";
import Common from '@/common.js'
import Authentication from '@/authentication.js';
//import EventBus from '@/EventBus.js'
import $ from 'jquery'
//import { bus } from '@/main.js'

export default {
  name: 'FooterWeb',
  props: {
    msg: String
  },data: function(){
  return {
      results: {'categories':{},'cart':{},'cart_count':'0','session':{"is_login": false,"user_id": 0,"user_name":"","company_name": "","first_name": "","last_name": "","user_type": ""}}
    }
  },
  computed:mapGetters(["Session","Cart","CartCount","AllCategories"]),
    watch:{
    AllCategories(newValue) { this.get_response(newValue)  },
    Session(newValue) { this.get_session_response(newValue)  },
    Cart(newValue) { this.response_cart_items(newValue)  },
    CartCount(newValue) { this.results.cart_count = newValue  },
  },
  mounted(){
      //switch(this.$route.name)
      //{
      //  case "About":
      //      document.addEventListener("backbutton", this.yourCallBackFunction, false);
      //    break
      //  
      //}
    
 //     //document.addEventListener("backbutton", this.yourCallBackFunction, false);
  },
  methods:{

    ...mapActions(["removeFromCart","getCart","getSession","logoutSession"]),
    placeOrder:function()
    {
      //EventBus.$emit('placeOrder','');
      $("#btnPlaceOrder").trigger("click");
    },
    Logout:function()
    {
            this.logoutSession();
            this.$router.push("/login");
    },
    loadSessionValues:function()
    {
        this.get_response(this.AllCategories);
        this.get_session_response(this.Selection);
        this.response_cart_items(this.Cart);
        this.results.cart_count = this.CartCount;
    },
    get_response:function(response)
    {  
        //var rdata = JSON.parse(response);
        var rdata = response;
        this.results.categories = rdata;
        //this.$store.dispatch("setSession", rdata);
    },
    get_session_response:function(response)
  {	
  //var rdata = JSON.parse(response);
  var rdata = response;
  this.results.session = rdata;
  //Authentication.setSession(rdata);
  Authentication.session = rdata;

  //this.$store.dispatch("setSession", rdata);

  //EventBus.$emit('set_session', rdata);
  Common.stopAjaxLoader();
  },
  response_cart_items:function(response)
  {
      //console.log(response);
      //var rdata1 = {"cartTotal":0,"PanelTitle":title,"Rows":JSON.parse(response)}
      var rdata1 = response;
      this.results.cart = rdata1;
      Common.stopAjaxLoader();
  },
  response_cart:function(response)
  {
      //alert(response);
      var rdata = JSON.parse(response);
      this.results.cart_count = rdata.cart_count;
      //this.setCartItemCount(rdata.cart_count);
  }
  //,RemoveFromCart:function(e,id)
  //{
  //    //Common.callServerFunction("Cart/CartController::RemoveFromCart",this.response_cart_items,{'pid':id},"View Cart");
  //}
  //,setCartItemCount:function(item_count)
  //{
  //    //$("#divcart_item").html(item_count);
  //}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>